import FetchError from './FetchError';
import { prethrowError } from './prethrowError';

export const fetchJson = async <T>(
  input: RequestInfo,
  init?: RequestInit
): Promise<T> => {
  const error = prethrowError(new FetchError({requestInfo: input, requestInit: init}));
  let response: Response | undefined;
  try {
    response = await fetch(input, init);
    error.updateDetails({response});

    if (!response.ok) {
      error.updateDetails({message: response.statusText});
      throw error;
    }

    return await response.json();
  } catch (e) {
    if (e instanceof FetchError) {
      throw e;
    }

    // throw new Error, because we want a full stack trace
    // and `fetch` doesn't seem to have one (at least on Chrome)
    error.updateDetails({wrappedError: error, message: `${e}`})
    throw error;
  }
};
